export const ALL_ROLES = [
  { id: 1, name: "SuperAdmin" },
  { id: 2, name: "Admin" },
  { id: 3, name: "branch-manager" },
  { id: 4, name: "branch-staff" },
  { id: 5, name: "ck-manager" },
  { id: 6, name: "ck-staff" },
] as const;

export type ApiRoleName = (typeof ALL_ROLES)[number]["name"];

export const ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  BRANCH_MANAGER: "branch_manager",
  BRANCH_STAFF: "branch_staff",
  CK_MANAGER: "ck_manager",
  CK_STAFF: "ck_staff",
} as const;

export type UserRole = (typeof ROLES)[keyof typeof ROLES];

const API_NAME_TO_ROLE: Record<string, UserRole> = {
  SuperAdmin: ROLES.SUPER_ADMIN,
  Admin: ROLES.ADMIN,
  "branch-manager": ROLES.BRANCH_MANAGER,
  "branch-staff": ROLES.BRANCH_STAFF,
  "ck-manager": ROLES.CK_MANAGER,
  "ck-staff": ROLES.CK_STAFF,
};

const ROLE_ID_MAP = Object.fromEntries(
  ALL_ROLES.map((role) => [role.id, role.name]),
) as Record<number, ApiRoleName>;

const ROLE_NAME_TO_ID = Object.fromEntries(
  ALL_ROLES.map((role) => [role.name, role.id]),
) as Record<ApiRoleName, number>;

/** Map API role name to normalized slug; unknown values fallback to branch_staff. */
export function normalizeRole(name: string | undefined | null): UserRole {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return ROLES.BRANCH_STAFF;
  return API_NAME_TO_ROLE[trimmed] ?? ROLES.BRANCH_STAFF;
}

export function getRoleById(id: number): (typeof ALL_ROLES)[number] | undefined {
  const name = ROLE_ID_MAP[id];
  if (!name) return undefined;
  return ALL_ROLES.find((role) => role.name === name);
}

export function getRoleByName(name: string): (typeof ALL_ROLES)[number] | undefined {
  return ALL_ROLES.find((role) => role.name === name);
}

export function getRoleIdByName(name: ApiRoleName): number {
  return ROLE_NAME_TO_ID[name];
}
